import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../lib/cn.js';
import { TriangleAlert } from '../../icons/index.js';
let idCounter = 0;
/** Stable-enough id generator for field wiring; React's `useId` is used at the call site instead where possible. */
export function nextFieldId(prefix) {
    idCounter += 1;
    return `${prefix}-${idCounter}`;
}
/**
 * Computes the shared wiring every form field needs: a label `htmlFor`, a helper-text
 * id, an error-text id, and the combined `aria-describedby`. Error text is announced via
 * `aria-live="polite"` on its own region (§7.5) and rendered *below* the field (§6 #4).
 */
export function useFieldChrome({ id, helperText, errorText, }) {
    const helperId = helperText ? `${id}-helper` : undefined;
    const errorId = errorText ? `${id}-error` : undefined;
    const describedBy = [helperId, errorId].filter(Boolean).join(' ') || undefined;
    return { helperId, errorId, describedBy };
}
export function FieldLabel({ htmlFor, id, children, required, optionalHint, }) {
    return (_jsxs("label", { htmlFor: htmlFor, id: id, className: "mb-1 block text-sm font-semibold text-text-primary", children: [children, required ? (_jsx("span", { "aria-hidden": "true", className: "ml-1 text-status-critical-solid", children: "*" })) : null, optionalHint && !required ? _jsx("span", { className: "ml-1 font-normal text-text-muted", children: "(optional)" }) : null] }));
}
export function FieldHelperText({ id, children }) {
    return (_jsx("p", { id: id, className: "mt-1 text-sm text-text-muted", children: children }));
}
export function FieldErrorText({ id, children }) {
    return (_jsxs("p", { id: id, role: "alert", "aria-live": "polite", className: cn('mt-1 flex items-center gap-1 text-sm text-status-critical-solid'), children: [_jsx(TriangleAlert, { "aria-hidden": "true", width: 14, height: 14, className: "mt-0.5 shrink-0" }), children] }));
}
//# sourceMappingURL=field-message.js.map